import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

export type BulletinCategory = 'daily' | 'yanshen' | 'monthly';

export interface BulletinEntry {
  key: string;
  filename: string;
  size_kb: number;
}

export interface BulletinDatesResponse {
  category: BulletinCategory;
  label: string;
  entries: BulletinEntry[];
  total: number;
}

export function useBulletinDates(category: BulletinCategory) {
  return useQuery({
    queryKey: ['weather-bulletin', 'dates', category],
    queryFn: async () => {
      const res = await apiClient.get<BulletinDatesResponse>('/weather-bulletin/dates', {
        params: { category },
      });
      return res.data;
    },
    staleTime: 10 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export function getBulletinPdfUrl(entryKey: string, category: BulletinCategory): string {
  const encodedKey = encodeURIComponent(entryKey);
  return `/api/v1/weather-bulletin/pdf/${encodedKey}?category=${category}`;
}
